<div class="user-rewards-list-container" *transloco="let t">
  <div class="rewards-info-container" (swipedown)="close()">
    <app-closable-bottom-sheet-handle (close)="close()"></app-closable-bottom-sheet-handle>
    <div class="total-promo-amount">${{ data.rewardsSum | moneyFormat }}</div>
    <div class="subtitle">{{ t('userRewardsSlideIn.subtitle') }}</div>
    <div>
      <button mat-flat-button class="button-medium loyalty" (click)="withdraw()">{{ t('userRewardsSlideIn.withdraw')}}</button>
    </div>
  </div>
  <div class="table">
      <div class="unscrollable-container">
        <div class="campaigns-container">
          @for (campaign of campaigns(); track campaign) {
            <div class="row">
              <div class="first-column">
                <img [src]="campaign.logoUrl" width="32px" height="32px" alt="merchant logo" class="merchant-logo">
                <div class="data">
                  <div class="merchant-name">{{ campaign.merchantName }}</div>
                  <div class="date">{{ campaign.date }}</div>
                </div>
              </div>
              <div class="second-column">${{ campaign.reward | moneyFormat }}</div>
            </div>
        }
        </div>
    </div>
  </div>
</div>
